import { useState } from 'react';
import useSettingsService from 'components/hooks/useSettingsService';
import {
  FEATURE_FLAGS_NAMES,
  DefinitionLevels,
  SettingValues
} from '@linearb/linjs-common';
import { tableMetricsNamesInitialState } from '../groupDashboard.service';
import { getTableColsTitlesInitialState } from './GroupMetricsTable.service';
import GroupMetricsDashboardTable from './GroupMetricsDashboardTable';
import GroupMetricsDashboardTableNew from './GroupMetricsDashboardTableNew';

const GroupMetricsTable = ({
  selectedGroup,
  contributorsById,
  availableMetricsWidgets,
  toggleModal,
  gitScopeToggle,
  setIsTableLoading
}) => {
  const { getSettingOrDefinitionValue, updateSetting } = useSettingsService();
  const isCustomizeMetrics = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.groupDashboardMetricsCustomizeEnabled
  });
  const isNewGroupDashboardTableEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.newGroupDashboardTableEnabled
  });

  const groupId = selectedGroup?.[0]?.id;
  const tableColsMetricsNamesInitialStateSettingValue =
    getSettingOrDefinitionValue({
      name: SettingValues.GROUP_DASHBOARD_METRICS_TABLE_COLS,
      definitionLevel: DefinitionLevels.TEAM,
      teamId: groupId
    });

  const [tableMetricsNames, setTableMetricsNames] = useState(
    tableColsMetricsNamesInitialStateSettingValue ||
      tableMetricsNamesInitialState
  );

  const tableColsTitlesInitialStateModal = getTableColsTitlesInitialState(
    availableMetricsWidgets,
    tableMetricsNames
  );

  const tableProps = {
    selectedGroup,
    contributorsById,
    availableMetricsWidgets,
    toggleModal,
    tableColsMetricsNamesInitialStateSettingValue,
    tableMetricsNames,
    setTableMetricsNames,
    tableColsTitlesInitialStateModal,
    updateSetting,
    isCustomizeMetrics,
    gitScopeToggle,
    setIsTableLoading
  };

  return isNewGroupDashboardTableEnabled ? (
    <GroupMetricsDashboardTableNew {...tableProps} />
  ) : (
    <GroupMetricsDashboardTable {...tableProps} />
  );
};

export default GroupMetricsTable;
